document.querySelectorAll('.raketenerna').forEach(section => {
	const audio = section.querySelector('audio')
	const listenButtons = section.querySelectorAll('#erna #listen, #erna-mobile #listen, .listen')
	const pauseButtons = section.querySelectorAll('#erna #pause-button, #erna-mobile #pause-button, .pause')
	const youtubeButtons = section.querySelectorAll('#erna #youtube, #erna-mobile #youtube, .youtube')
	const spotifyButtons = section.querySelectorAll('#erna #spotify, #erna-mobile #spotify, .spotify')
	const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
	const showPauseButtons = () => pauseButtons.forEach(button => button.style.display = 'inline')
	const hidePauseButtons = () => pauseButtons.forEach(button => button.style.display = 'none')
	const startAudio = () => {
		audio.muted = false
		audio.play().catch(() => {})
	}
	const pauseAudio = () => audio.pause()
	audio.style.display = 'none'
	hidePauseButtons()

	youtubeButtons.forEach(button => {
		button.addEventListener('click', () => window.open(section.dataset.youtube, '_blank'))
	})

	spotifyButtons.forEach(button => {
		button.addEventListener('click', () => window.open(section.dataset.spotify, '_blank'))
	})

	pauseButtons.forEach(button => {
		button.style.cursor = 'pointer'
		button.addEventListener('click', pauseAudio)
	})

	audio.addEventListener('play', showPauseButtons)
	audio.addEventListener('pause', hidePauseButtons)
	audio.addEventListener('ended', hidePauseButtons)

	if (isChrome) {
		listenButtons.forEach(button => {
			button.style.cursor = 'pointer'
			button.addEventListener('click', startAudio)
		})
	} else {
		const observer = new IntersectionObserver(([entry]) => {
			if (!entry.isIntersecting) return
			startAudio()
			observer.unobserve(section)
		}, {
			root: null,
			threshold: .4
		})

		observer.observe(section)
	}
})
